import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "../../../redux/reducers";
import { useNavigate } from "react-router-dom";
import { routeUtils } from "../../../utils/route-utils";
import Table, { IColumnDefinition } from "../../shared-ui/table/table";
import styles from "./storage-provider-table.module.scss";
import { AccountType } from "api/entities/account";
import { getOwnerColumn } from "../../common/sections/owner-column/owner-column";
import { storageNodeProviderThunkActions } from "redux/actions/storage-provider";
import {
  IStorageNodeProviderDetailItem,
  IStorageNodeProviderFind,
  StorageNodeProviderSortField,
} from "api/entities/storage-node-providers";

function mapDispatchToProps(dispatch: ThunkDispatch<IAppState, void, Action>) {
  return {
    fetchPage: (requestParams: IStorageNodeProviderFind) => {
      return dispatch(
        storageNodeProviderThunkActions.entity.fetchPage(requestParams),
      );
    },
  };
}

const mapStateToProps = (state: IAppState) => ({
  accountType: state.users.currentUser.accountType,

  page: state.storageProvider.page,
  selection: state.storageProvider.selection,
});

interface IStorageProviderTableProps
  extends
    ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

export const StorageProviderTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: IStorageProviderTableProps) => {
  const navigate = useNavigate();

  function getV2OwnerColumn() {
    return props.accountType === AccountType.Enterprise
      ? [
          getOwnerColumn<
            IStorageNodeProviderDetailItem,
            StorageNodeProviderSortField
          >(null, styles["col--owner"]),
        ]
      : [];
  }

  const columns: IColumnDefinition<
    IStorageNodeProviderDetailItem,
    StorageNodeProviderSortField
  >[] = [
    {
      label: "Name",
      className: styles["col--name"],
      formatter: (row: IStorageNodeProviderDetailItem) => row.name,
      sortKey: StorageNodeProviderSortField.Name,
    },
    {
      label: "Provider",
      className: styles["col--provider"],
      formatter: (row: IStorageNodeProviderDetailItem) => row.provider,
      sortKey: StorageNodeProviderSortField.Provider,
    },
    {
      label: "Access Key ID",
      className: styles["col--Default"],
      formatter: (row: IStorageNodeProviderDetailItem) => row.accessKeyId,
    },
    {
      label: "Repository Count",
      className: styles["col--Default"],
      formatter: (row: IStorageNodeProviderDetailItem) =>
        row.storageNodes.length,
    },
    ...getV2OwnerColumn(),
    // {
    //     label: "Manage",
    //     className: tableStyles["col--manage"],
    //     formatter: row => (<MoreOption data={row}/>),
    // }
  ];

  return (
    <Table
      testId="storage-provider-table"
      hideCheckbox={true}
      columns={columns}
      rows={props.page.entities}
      totalRows={props.page.count}
      loading={props.page.isLoading}
      requestParams={props.page.searchParams}
      onRequestParamsChanged={(params: any) => props.fetchPage(params)}
      onRowClick={(row) =>
        navigate(routeUtils.getRouteToStorageProviderDetails(row.id))
      }
      responsive={true}
    />
  );
});
